import React, { useState } from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import { GridLegacy, Typography } from "@mui/material";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

import { talenV5 } from "../../../variables/app";
import FormFieldTwoColumns from "../../../components/Forms/Layouts/FormFieldTwoColumns";
import { useController } from "react-hook-form";
import _ from "lodash";
import Editor from "../../SunEditor";

export default function DetailedDescription() {
  const [translationsInit, setTranslationsInit] = useState({});

  const {
    field: { value: translationsValue, onChange: translationsOnChange },
  } = useController({ name: "translations" });

  if (Object.keys(translationsInit).length === 0 && translationsValue !== null) {
    setTranslationsInit(translationsValue);
  }

  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <GridLegacy container spacing={1}>
        <GridLegacy item lg={6} xs={12}>
          <Card>
            <CardBody style={{ padding: 16 }}>
              <GridLegacy container spacing={1}>
                <GridLegacy item xs={12}>
                  <Typography component={"h3"}>
                    <TranslationWrapper
                      tDefault={"Detailed description"}
                      tKey={"producten.form.tabs.vertalingDetailedDescription"}
                    />
                  </Typography>
                  {Object.keys(talenV5).map((objKey) => {
                    let taal = talenV5[objKey];

                    return (
                      <FormFieldTwoColumns key={objKey} tDefault={taal.label} tKey={"global." + taal.transKey}>
                        <Editor
                          defaultValue={translationsInit[objKey]?.detailed_description ?? ""}
                          key={translationsInit[objKey]?.detailed_description ?? ""}
                          onChange={(changedContent) => {
                            let translations = _.cloneDeep(translationsValue) ?? {};

                            if (!(objKey in translations)) {
                              translations[objKey] = {};
                            }

                            translations[objKey].detailed_description = changedContent;
                            translationsOnChange(translations);
                          }}
                          textareaName={"translations." + objKey + ".detailed_description"}
                        />
                      </FormFieldTwoColumns>
                    );
                  })}
                </GridLegacy>
              </GridLegacy>
            </CardBody>
          </Card>
        </GridLegacy>
      </GridLegacy>
    </div>
  );
}
